// extracted by mini-css-extract-plugin
export var btn = "bb_mB G_tw G_tq d_bz d_bP d_bD d_dw";
export var full = "bb_yf d_w d_H";
export var hoverStyle = "bb_mF";
export var zoom = "bb_mG";